/* TASK 20 (Φ4) — Collection filter engine
 * Spec (BACKLOG #20, locked): OR εντός κατηγορίας · AND μεταξύ κατηγοριών ·
 * apply/pagination ΧΩΡΙΣ refresh (AJAX) · price slider (δυναμικά όρια ανά
 * συλλογή, τελική/sale τιμή με ΦΠΑ, variant-aware: pMin≤hi ΚΑΙ pMax≥lo,
 * πλήρες εύρος = καμία επίδραση) · κανένα φίλτρο = όλα τα προϊόντα.
 * Αρχιτεκτονική: data-view ?view=filter-data επιστρέφει tags/τιμές + την ΙΔΙΑ
 * server-rendered κάρτα (μηδέν markup drift)· τα native link_to_add/remove_tag
 * μένουν no-JS/crawl fallback· σε engine-σφάλμα → native navigation.
 */
(function () {
  var root = document.querySelector('[data-collection-root]');
  var grid = document.querySelector('[data-product-grid]');
  if (!root || !grid) return;

  var pagWrap = document.querySelector('[data-collection-pagination]');
  var emptyEl = document.querySelector('[data-engine-empty]');
  var refinedBlock = document.querySelector('[data-refined-block]');
  var refinedChips = document.querySelector('[data-refined-chips]');
  var priceFilter = document.querySelector('[data-price-filter]');
  var descBlock = document.querySelector('[data-collection-description]');
  var perPage = parseInt(root.getAttribute('data-engine-per-page'), 10) || 24;
  var collectionUrl = root.getAttribute('data-collection-url');

  var sel = {};          // groupTitle -> { tag: true }
  var priceSel = null;   // [lo, hi] σε ευρώ
  var bounds = null;     // [lo, hi] σε ευρώ (δυναμικά ανά συλλογή)
  var data = null;
  var dataPromise = null;
  var enginePage = 1;
  var engineOn = false;
  var engineBroken = false;
  var snapshot = { grid: grid.innerHTML, pag: pagWrap ? pagWrap.innerHTML : '' };

  // ---------- helpers ----------
  function selectedCount() {
    var n = 0;
    for (var g in sel) n += Object.keys(sel[g]).length;
    return n;
  }
  function priceActive() {
    // πλήρες εύρος (min–max τέρμα) → σαν να μην αγγίχτηκε (spec)
    return !!(priceSel && bounds && (priceSel[0] > bounds[0] || priceSel[1] < bounds[1]));
  }
  function anyActive() { return selectedCount() > 0 || priceActive(); }

  function matches(p) {
    // AND μεταξύ κατηγοριών — OR εντός κατηγορίας
    for (var g in sel) {
      var tags = Object.keys(sel[g]);
      if (!tags.length) continue;
      var hit = false;
      for (var i = 0; i < tags.length; i++) {
        if (p.tags.indexOf(tags[i]) !== -1) { hit = true; break; }
      }
      if (!hit) return false;
    }
    if (priceActive()) {
      var lo = priceSel[0] * 100, hi = priceSel[1] * 100;
      // variant-aware (spec): min(variant)≤hi ΚΑΙ max(variant)≥lo — τελικές τιμές
      if (!(p.priceMin <= hi && p.priceMax >= lo)) return false;
    }
    return true;
  }

  // ---------- data ----------
  // Κοινός φορτωτής paginated views: σελίδα-1 → μαθαίνει pages → 2..N ΠΑΡΑΛΛΗΛΑ
  // (owner-feedback Σ07-10: το σειριακό κόστιζε δευτερόλεπτα στα μεγάλα datasets)
  function fetchAllPages(baseUrl, onFirstPage) {
    function getPage(n) {
      return fetch(baseUrl + '&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('page ' + r.status); return r.json(); });
    }
    return getPage(1).then(function (first) {
      if (onFirstPage) { try { onFirstPage(first.products); } catch (e) {} }
      var pages = first.pages || 1;
      if (pages <= 1) return first.products;
      var rest = [];
      for (var n = 2; n <= pages; n++) rest.push(getPage(n));
      return Promise.all(rest).then(function (results) {
        var all = first.products;
        results.forEach(function (j) { all = all.concat(j.products); });
        return all;
      });
    });
  }

  function fetchData() {
    if (dataPromise) return dataPromise;
    // TASK 62στ: στο /search το data-view χρειάζεται q/type — διατηρούνται
    // από το location (αβλαβές στις συλλογές όπου δεν υπάρχουν)
    var locP = new URLSearchParams(location.search);
    var qs = '?view=filter-data';
    ['q', 'type', 'sort_by'].forEach(function (k) {
      var v = locP.get(k);
      if (v) qs += '&' + k + '=' + encodeURIComponent(v);
    });
    dataPromise = fetchAllPages(collectionUrl + qs).then(function (all) {
      data = all;
      widenBounds(computeBounds(all));
      pruneEmptyOptions();
      return all;
    }).catch(function (e) {
      engineBroken = true;
      dataPromise = null;
      throw e;
    });
    return dataPromise;
  }

  // TASK 62στ (data-prune-empty, /search): τα groups εδώ είναι στατικά
  // αντίγραφα των συλλογών — κρύψε options/groups χωρίς κανένα ταίριασμα
  // στο τρέχον dataset ώστε ο χρήστης να μη βλέπει «νεκρά» φίλτρα.
  function pruneEmptyOptions(src) {
    src = src || data;
    if (!root.hasAttribute('data-prune-empty') || !src) return;
    var items = document.querySelectorAll('[data-filter-item]');
    Array.prototype.forEach.call(items, function (li) {
      var t = li.getAttribute('data-tag');
      var has = src.some(function (p) { return p.tags.indexOf(t) !== -1; });
      li.style.display = has ? '' : 'none';
    });
    var groups = document.querySelectorAll('[data-filter-group]');
    Array.prototype.forEach.call(groups, function (g) {
      var lis = g.querySelectorAll('[data-filter-item]');
      var any = false;
      Array.prototype.forEach.call(lis, function (li) { if (li.style.display !== 'none') any = true; });
      g.style.display = any ? '' : 'none';
    });
    // άρση του loading-veil (search: τα φίλτρα κρυμμένα μέχρι το prune)
    var panel = document.querySelector('[data-filters-loading]');
    if (panel) panel.removeAttribute('data-filters-loading');
  }

  // TASK 62ζ: ΕΛΑΦΡΥ tags-only fetch (data-lite-view) — prune + price bounds
  // ΑΜΕΣΩΣ στο load, χωρίς να περιμένουν το βαρύ dataset με τις κάρτες
  var litePromise = null;
  function fetchLite() {
    var view = root.getAttribute('data-lite-view');
    if (!view) return Promise.resolve(null);
    if (litePromise) return litePromise;
    var locP = new URLSearchParams(location.search);
    var qs = '?view=' + view;
    ['q', 'type', 'sort_by'].forEach(function (k) {
      var v = locP.get(k);
      if (v) qs += '&' + k + '=' + encodeURIComponent(v);
    });
    // Owner-feedback Σ07-10 (×2): «να φορτώνει άμεσα» —
    // (α) sessionStorage cache ανά query (TTL 10′): επανάληψη/πίσω = 0ms
    // (β) early-reveal: prune με την 1η σελίδα (μόνο ΠΡΟΣΘΗΚΕΣ ακολουθούν —
    //     ό,τι φανεί με βάση το δείγμα δεν αφαιρείται ποτέ μπροστά στον χρήστη)
    var cacheKey = 'cfLite2:' + location.pathname + qs; // v2: +available (TASK 65)
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.t < 600000 && cached.d) {
        litePromise = Promise.resolve(cached.d);
        finishLite(cached.d);
        return litePromise;
      }
    } catch (e) { /* γεμάτο/κλειδωμένο storage — συνέχισε κανονικά */ }

    litePromise = fetchAllPages(collectionUrl + qs, function (firstPage) {
      pruneEmptyOptions(firstPage); // early-reveal με το 1ο 250άρι δείγμα
      widenBounds(computeBounds(firstPage)); // TASK 20γ: μπάρα τιμής ΑΜΕΣΑ με το δείγμα
    }).then(function (all) {
      finishLite(all);
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: all })); } catch (e) {}
      return all;
    }).catch(function () { litePromise = null; return null; });
    return litePromise;
  }

  function finishLite(all) {
    widenBounds(computeBounds(all));
    pruneEmptyOptions(all);
  }

  // ---------- price UI ----------
  var rMin, rMax, iMin, iMax, track;

  // Κοινός υπολογισμός ορίων τιμής από dataset (cents → €, floor/ceil)
  function computeBounds(list) {
    var lo = Infinity, hi = 0;
    list.forEach(function (p) {
      if (p.priceMin < lo) lo = p.priceMin;
      if (p.priceMax > hi) hi = p.priceMax;
    });
    return list.length ? [Math.floor(lo / 100), Math.ceil(hi / 100)] : [0, 0];
  }

  // TASK 20γ: τα όρια ΜΟΝΟ διευρύνονται μπροστά στον χρήστη — η μπάρα
  // εμφανίζεται αμέσως με το δείγμα της 1ης σελίδας και «ανοίγει» αθόρυβα
  // αν το πλήρες dataset φέρει φθηνότερο/ακριβότερο (ίδια αρχή με το
  // early-reveal του prune: ποτέ αφαίρεση/μάζεμα μετά την εμφάνιση)
  function widenBounds(nb) {
    if (!bounds) { bounds = nb; initPriceUI(); return; }
    if (nb[0] >= bounds[0] && nb[1] <= bounds[1]) return;
    var wasFull = !priceActive(); // πριν πειραχτούν τα bounds
    bounds = [Math.min(bounds[0], nb[0]), Math.max(bounds[1], nb[1])];
    if (!rMin) return;
    [rMin, rMax].forEach(function (r) { r.min = bounds[0]; r.max = bounds[1]; });
    if (wasFull) priceSel = [bounds[0], bounds[1]]; // αν δεν άγγιξε τις λαβές → μένει «πλήρες εύρος»
    syncPriceUI();
  }
  function initPriceUI() {
    if (!priceFilter || priceFilter.dataset.ready) return;
    priceFilter.dataset.ready = '1';
    rMin = priceFilter.querySelector('[data-price-range-min]');
    rMax = priceFilter.querySelector('[data-price-range-max]');
    iMin = priceFilter.querySelector('[data-price-min-input]');
    iMax = priceFilter.querySelector('[data-price-max-input]');
    track = priceFilter.querySelector('[data-price-track]');
    [rMin, rMax].forEach(function (r) { r.min = bounds[0]; r.max = bounds[1]; });
    if (!priceSel) priceSel = [bounds[0], bounds[1]];
    syncPriceUI();
    priceFilter.hidden = false;

    rMin.addEventListener('input', function () {
      priceSel[0] = Math.min(parseInt(rMin.value, 10), priceSel[1]);
      syncPriceUI();
    });
    rMax.addEventListener('input', function () {
      priceSel[1] = Math.max(parseInt(rMax.value, 10), priceSel[0]);
      syncPriceUI();
    });
    rMin.addEventListener('change', applyFromPrice);
    rMax.addEventListener('change', applyFromPrice);
    [iMin, iMax].forEach(function (inp, idx) {
      inp.addEventListener('change', function () {
        var v = parseInt(inp.value, 10);
        if (isNaN(v)) v = idx === 0 ? bounds[0] : bounds[1];
        v = Math.max(bounds[0], Math.min(bounds[1], v));
        priceSel[idx] = v;
        if (priceSel[0] > priceSel[1]) priceSel[idx === 0 ? 1 : 0] = v;
        syncPriceUI();
        applyFromPrice();
      });
    });
  }
  function syncPriceUI() {
    if (!rMin) return;
    rMin.value = priceSel[0];
    rMax.value = priceSel[1];
    iMin.value = priceSel[0];
    iMax.value = priceSel[1];
    var span = Math.max(1, bounds[1] - bounds[0]);
    track.style.setProperty('--range-lo', ((priceSel[0] - bounds[0]) / span * 100) + '%');
    track.style.setProperty('--range-hi', ((priceSel[1] - bounds[0]) / span * 100) + '%');
  }
  function applyFromPrice() { apply(1, true); }

  // ---------- render ----------
  function setLoading(on) { grid.classList.toggle('is-loading', on); }

  var lastNativeHref = null; // fallback: αν πέσει ο engine, το κλικ δεν χάνεται

  function apply(page, push) {
    setLoading(true);
    fetchData().then(function () {
      if (!anyActive()) { restore(push); setLoading(false); return; }
      engineOn = true;
      render(page || 1);
      if (push !== false) updateURL();
      setLoading(false);
    }).catch(function () {
      setLoading(false);
      if (lastNativeHref) location.href = lastNativeHref;
    });
  }

  function render(page) {
    var items = data.filter(matches);
    // TASK 65: εξαντλημένα ΠΑΝΤΑ στο τέλος (σταθερή σειρά εντός κάθε ομάδας —
    // guard σε undefined: χωρίς available flag = μεταχείριση διαθέσιμου)
    var t65avail = [], t65sold = [];
    items.forEach(function (p) { (p.available === false ? t65sold : t65avail).push(p); });
    items = t65avail.concat(t65sold);
    var pages = Math.max(1, Math.ceil(items.length / perPage));
    enginePage = Math.min(Math.max(1, page), pages);
    var slice = items.slice((enginePage - 1) * perPage, enginePage * perPage);
    grid.innerHTML = slice.map(function (p) {
      return '<div class="product-grid__item">' + p.html + '</div>';
    }).join('');
    grid.style.display = slice.length ? '' : 'none';
    if (emptyEl) emptyEl.hidden = slice.length !== 0;
    renderPagination(items.length, pages);
    renderChips();
    syncChecks();
    if (descBlock) descBlock.hidden = enginePage !== 1;
  }

  // Κοινός builder (filtered engine + TASK 65 two-stream) — attr = ποιο
  // data-attribute κουβαλούν τα links (καθορίζει τον click-router)·
  // fromTo προαιρετικό override [from, to] (two-stream: η τελευταία in-stock
  // σελίδα είναι μερική → η ομοιόμορφη αριθμητική θα έδειχνε λάθος αφετηρία)·
  // hrefFn(n) → πραγματικό crawlable URL ανά σελίδα (SEO — AUDIT Β2): ο click-
  // router κάνει preventDefault, το href υπάρχει για crawlers/νέα-καρτέλα/fallback
  function paginationHtml(current, pages, total, attr, fromTo, hrefFn) {
    var from = fromTo ? fromTo[0] : (total === 0 ? 0 : (current - 1) * perPage + 1);
    var to = fromTo ? fromTo[1] : Math.min(current * perPage, total);
    function hrefAt(n) { return hrefFn ? escapeAttr(hrefFn(n)) : '#'; }
    var html = '<p class="collection-pagination__count" data-collection-count>Προβολή: ' + from + ' - ' + to + ' από ' + total + '</p>';
    if (pages > 1) {
      html += '<nav class="pagination" aria-label="Σελιδοποίηση">';
      if (current > 1) html += '<a href="' + hrefAt(current - 1) + '" class="pagination__nav" ' + attr + '="' + (current - 1) + '">‹ ΠΡΟΗΓ.</a>';
      var parts = [];
      for (var n = 1; n <= pages; n++) {
        if (n === 1 || n === pages || Math.abs(n - current) <= 2) parts.push(n);
        else if (parts[parts.length - 1] !== '…') parts.push('…');
      }
      parts.forEach(function (part) {
        if (part === '…') html += '<span class="pagination__ellipsis">…</span>';
        else if (part === current) html += '<span class="pagination__num is-current" aria-current="page">' + part + '</span>';
        else html += '<a href="' + hrefAt(part) + '" class="pagination__num" ' + attr + '="' + part + '">' + part + '</a>';
      });
      if (current < pages) html += '<a href="' + hrefAt(current + 1) + '" class="pagination__nav" ' + attr + '="' + (current + 1) + '">ΕΠΟΜΕΝΟ ›</a>';
      html += '</nav>';
    }
    return html;
  }

  // AUDIT Β2: crawlable href για τις engine-σελίδες — καθρέφτης του updateURL
  // (f/price/fp) ώστε το deep-link να αναπαράγει ακριβώς την ίδια προβολή
  function engineHref(n) {
    var u = new URL(collectionUrl, location.origin);
    var params = new URLSearchParams(location.search);
    params.delete('page');
    var fParts = [];
    for (var g in sel) {
      var tags = Object.keys(sel[g]);
      if (tags.length) fParts.push(escF(g) + ':' + tags.map(escF).join('|')); // Β4β: single-encode (βλ. updateURL)
    }
    if (fParts.length) params.set('f', fParts.join(';')); else params.delete('f');
    if (priceActive()) params.set('price', priceSel[0] + '-' + priceSel[1]); else params.delete('price');
    if (n > 1) params.set('fp', n); else params.delete('fp');
    var q = params.toString();
    return u.pathname + (q ? '?' + q : '');
  }

  function renderPagination(total, pages) {
    if (!pagWrap) return;
    pagWrap.innerHTML = paginationHtml(enginePage, pages, total, 'data-engine-page', null, engineHref);
  }

  function renderChips() {
    if (!refinedBlock || !refinedChips) return;
    var html = '';
    for (var g in sel) {
      for (var t in sel[g]) {
        var li = document.querySelector('[data-filter-item][data-tag="' + cssEscape(t) + '"]');
        var display = li ? li.getAttribute('data-display') : t;
        html += '<li><a href="#" data-engine-remove-tag="' + escapeAttr(t) + '" data-engine-group="' + escapeAttr(g) + '">' + escapeHtml(display) + '</a></li>';
      }
    }
    refinedChips.innerHTML = html;
    refinedBlock.hidden = html === '';
  }

  function syncChecks() {
    document.querySelectorAll('[data-filter-item]').forEach(function (li) {
      var g = li.closest('[data-filter-group]');
      var gName = g ? g.getAttribute('data-filter-group') : '';
      var t = li.getAttribute('data-tag');
      li.classList.toggle('is-checked', !!(sel[gName] && sel[gName][t]));
    });
  }

  function restore(push) {
    engineOn = false;
    enginePage = 1;
    grid.innerHTML = snapshot.grid;
    grid.style.display = '';
    if (emptyEl) emptyEl.hidden = true;
    if (pagWrap) pagWrap.innerHTML = snapshot.pag;
    if (descBlock) descBlock.hidden = false;
    renderChips();
    syncChecks();
    if (push !== false) updateURL();
  }

  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function escapeAttr(s) { return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function cssEscape(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/["\\]/g, '\\$&'); }

  // ---------- URL state ----------
  // AUDIT Β4β: στο f-format escape ΜΟΝΟ τα delimiters (% πρώτο — μετά : ; |)·
  // το URL-encoding γίνεται ΜΙΑ φορά, από το URLSearchParams.toString().
  // (Το παλιό encodeURIComponent + toString = διπλό encode → άσχημα %25CE URLs.
  // Το parseURL μένει ίδιο: get() αποκωδικοποιεί μία, decodeURIComponent τα
  // escF-escapes — και τα ΠΑΛΙΑ double-encoded URLs διαβάζονται ακριβώς ίδια.)
  function escF(s) {
    return s.replace(/%/g, '%25').replace(/:/g, '%3A').replace(/;/g, '%3B').replace(/\|/g, '%7C');
  }
  function updateURL() {
    var u = new URL(collectionUrl, location.origin);
    var params = new URLSearchParams(location.search);
    if (engineOn) params.delete('page'); // server ?page= μένει μόνο στο restore
    var fParts = [];
    for (var g in sel) {
      var tags = Object.keys(sel[g]);
      if (tags.length) fParts.push(escF(g) + ':' + tags.map(escF).join('|'));
    }
    if (fParts.length) params.set('f', fParts.join(';')); else params.delete('f');
    if (priceActive()) params.set('price', priceSel[0] + '-' + priceSel[1]); else params.delete('price');
    if (engineOn && enginePage > 1) params.set('fp', enginePage); else params.delete('fp');
    var q = params.toString();
    history.pushState({ engine: true }, '', u.pathname + (q ? '?' + q : ''));
  }

  function parseURL() {
    var params = new URLSearchParams(location.search);
    var f = params.get('f');
    var price = params.get('price');
    sel = {};
    if (f) {
      f.split(';').forEach(function (part) {
        var ix = part.indexOf(':');
        if (ix < 1) return;
        var g = decodeURIComponent(part.slice(0, ix));
        sel[g] = {};
        part.slice(ix + 1).split('|').forEach(function (t) {
          if (t) sel[g][decodeURIComponent(t)] = true;
        });
      });
    }
    if (price && /^\d+-\d+$/.test(price)) {
      var pp = price.split('-');
      priceSel = [parseInt(pp[0], 10), parseInt(pp[1], 10)];
    } else if (bounds) {
      priceSel = [bounds[0], bounds[1]];
    } else {
      priceSel = null;
    }
    return { active: !!(f || price), page: parseInt(params.get('fp'), 10) || 1 };
  }

  // ---------- AJAX pagination στο ΑΦΙΛΤΡΑΡΙΣΤΟ mode (Section Rendering) ----------
  function sectionId() {
    var sec = root.closest('.shopify-section');
    return sec ? sec.id.replace(/^shopify-section-/, '') : null;
  }
  function ajaxServerPage(href, push) {
    var sid = sectionId();
    if (!sid) { location.href = href; return; }
    var u = new URL(href, location.origin);
    u.searchParams.set('sections', sid);
    setLoading(true);
    fetch(u.toString())
      .then(function (r) { if (!r.ok) throw new Error('sr ' + r.status); return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j[sid] || '', 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        var newPag = doc.querySelector('[data-collection-pagination]');
        if (!newGrid) throw new Error('no grid');
        grid.innerHTML = newGrid.innerHTML;
        if (pagWrap) pagWrap.innerHTML = newPag ? newPag.innerHTML : '';
        snapshot = { grid: grid.innerHTML, pag: pagWrap ? pagWrap.innerHTML : '' };
        var pg = parseInt(new URL(href, location.origin).searchParams.get('page'), 10) || 1;
        if (descBlock) descBlock.hidden = pg !== 1;
        if (push !== false) history.pushState({ srv: true }, '', href);
        // TASK 65 race-guard: native κλικ πριν προλάβει το lite → ευθυγράμμιση
        // με το two-stream (pagination + swap αν η σελίδα διαφέρει)
        if (ts) {
          tsPagination(pg);
          snapshot.pag = pagWrap ? pagWrap.innerHTML : '';
          if (pg >= ts.firstSoldPage) tsGo(pg, false, true);
        }
        scrollToGrid();
        setLoading(false);
      })
      .catch(function () { setLoading(false); location.href = href; });
  }
  function scrollToGrid() {
    var top = root.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  // ---------- TASK 65: εξαντλημένα στο ΤΕΛΟΣ της συλλογής (αφιλτράριστο mode) ----------
  // Native storefront filtering (filter.v.availability — live-verified Σ07-11:
  // kolie 322 → =1:309 / =0:13, σέβεται sort_by): server-rendered σελίδες
  // ΜΟΝΟ-διαθέσιμων / ΜΟΝΟ-εξαντλημένων. Ο engine σελιδοποιεί ΔΥΟ ρεύματα:
  // σελίδες 1..K = διαθέσιμα, K+1..P = εξαντλημένα → τα εξαντλημένα
  // ΚΥΡΙΟΛΕΚΤΙΚΑ στο τέλος. Ενεργό ΜΟΝΟ σε /collections/ με ≥1 εξαντλημένο
  // (αλλιώς μηδέν αλλαγή/κόστος)· swap του ορατού grid ΜΟΝΟ όταν η native
  // σελίδα διαφέρει από το two-stream περιεχόμενο (native σελίδες ΠΡΙΝ την
  // πρώτη εξαντλημένη θέση = ταυτόσημες → κανένα άγγιγμα)· σφάλμα → native.
  // ---------- TASK 65β (Σ08-01β): το παράθυρο-χρόνου ΔΕΝ δείχνει εξαντλημένα ----------
  // Native σελίδα με ΜΕΙΓΜΑ (διαθέσιμα+εξαντλημένα) = εγγυημένα «λάθος» υπό το
  // two-stream (τα εξαντλημένα ανήκουν στο τέλος) → κρύβονται ΑΜΕΣΩΣ στο load,
  // ΠΡΙΝ το lite-fetch (στο κινητό το fetch = δευτερόλεπτα ορατού μείγματος).
  // Fail-open πλήρες: αν ο engine δεν αναλάβει (lite σφάλμα / 0 εξαντλημένα /
  // self-check kill) → επανεμφάνιση· δίχτυ και με χρονόμετρο 12s.
  var earlyHidden = [];
  function restoreEarlyHidden() {
    earlyHidden.forEach(function (it) { it.hidden = false; });
    earlyHidden = [];
  }
  (function () {
    if (collectionUrl.indexOf('/collections/') !== 0) return;
    // TASK 65γ: τα server-prehidden (data-ts-prehide, Liquid) μπαίνουν στο ΙΔΙΟ
    // restore-δίχτυ — κάθε fail-open μονοπάτι τα επανεμφανίζει
    grid.querySelectorAll('[data-ts-prehide]').forEach(function (it) { earlyHidden.push(it); });
    if (location.search.indexOf('filter.') !== -1) { restoreEarlyHidden(); return; } // native-filtered view = ο engine αναλαμβάνει
    var soldCards = grid.querySelectorAll('.product-card--soldout');
    var allCards = grid.querySelectorAll('.product-card');
    if (!soldCards.length || soldCards.length === allCards.length) {
      if (!soldCards.length) restoreEarlyHidden(); // τίποτα soldout στο DOM = τίποτα κρυφό
      setTimeout(function () { if (!ts) restoreEarlyHidden(); }, 12000);
      return; // αμιγής σελίδα = σωστή
    }
    soldCards.forEach(function (c) {
      var it = c.closest('.product-grid__item') || c;
      if (it.hidden) return; // ήδη server-prehidden
      it.hidden = true;
      earlyHidden.push(it);
    });
    setTimeout(function () { if (!ts) restoreEarlyHidden(); }, 12000);
  })();

  var ts = null;
  function curServerPage() { return parseInt(new URLSearchParams(location.search).get('page'), 10) || 1; }
  function initTwoStream(liteAll) {
    if (ts || !liteAll || !liteAll.length) return;
    if (collectionUrl.indexOf('/collections/') !== 0) return; // /search: S&D setting, όχι εδώ
    var soldTotal = 0, firstSoldIdx = -1;
    liteAll.forEach(function (p, i) {
      if (p.available === false) { soldTotal++; if (firstSoldIdx === -1) firstSoldIdx = i; }
    });
    if (!soldTotal) return;
    var inTotal = liteAll.length - soldTotal;
    var inPages = Math.ceil(inTotal / perPage);
    ts = {
      total: liteAll.length,
      inTotal: inTotal,
      inPages: inPages,
      pages: inPages + Math.ceil(soldTotal / perPage),
      firstSoldPage: Math.floor(firstSoldIdx / perPage) + 1,
      nativePag: pagWrap ? pagWrap.innerHTML : '' // για fail-open επαναφορά (self-check)
    };
    if (!engineOn) {
      var cur = curServerPage();
      tsPagination(cur);
      snapshot.pag = pagWrap ? pagWrap.innerHTML : '';
      if (cur >= ts.firstSoldPage) tsGo(cur, false, true); // ήσυχο swap, χωρίς scroll
      else restoreEarlyHidden(); // edge: lite-order ≠ native (δεν αναμένεται) — τίποτα κρυφό
    }
  }
  function tsUrl(n) {
    var u = new URL(collectionUrl, location.origin);
    var sort = new URLSearchParams(location.search).get('sort_by');
    if (sort) u.searchParams.set('sort_by', sort);
    if (n <= ts.inPages) {
      u.searchParams.set('filter.v.availability', '1');
      if (n > 1) u.searchParams.set('page', String(n));
    } else {
      u.searchParams.set('filter.v.availability', '0');
      if (n - ts.inPages > 1) u.searchParams.set('page', String(n - ts.inPages));
    }
    return u;
  }
  function tsHref(n) {
    var u = new URL(collectionUrl, location.origin);
    var sort = new URLSearchParams(location.search).get('sort_by');
    if (sort) u.searchParams.set('sort_by', sort);
    if (n > 1) u.searchParams.set('page', String(n));
    return u.pathname + u.search;
  }
  function tsPagination(n) {
    if (!pagWrap) return;
    var fromTo;
    if (n <= ts.inPages) {
      fromTo = [(n - 1) * perPage + 1, Math.min(n * perPage, ts.inTotal)];
    } else {
      var m = n - ts.inPages;
      fromTo = [ts.inTotal + (m - 1) * perPage + 1, Math.min(ts.inTotal + m * perPage, ts.total)];
    }
    pagWrap.innerHTML = paginationHtml(n, ts.pages, ts.total, 'data-ts-page', fromTo, tsHref);
  }
  function tsGo(n, push, silent) {
    n = Math.min(Math.max(1, n), ts.pages);
    var sid = sectionId();
    if (!sid) { if (!silent) location.href = tsHref(n); return; }
    var u = tsUrl(n);
    u.searchParams.set('sections', sid);
    if (!silent) setLoading(true);
    fetch(u.toString())
      .then(function (r) { if (!r.ok) throw new Error('ts ' + r.status); return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j[sid] || '', 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (!newGrid) throw new Error('no grid');
        // Self-check (fail-open): αν το filter.v.availability ΔΕΝ τιμήθηκε
        // (π.χ. άλλαξε κάτι στο Search & Discovery), το ρεύμα θα έφερνε λάθος
        // μείγμα → απενεργοποίηση two-stream + επιστροφή στη native ροή —
        // ΠΟΤΕ λάθος περιεχόμενο μπροστά στον χρήστη.
        var strays = n <= ts.inPages
          ? newGrid.querySelectorAll('.product-card--soldout')
          : newGrid.querySelectorAll('.product-card:not(.product-card--soldout)');
        if (strays.length > 2) {
          var natPag = ts.nativePag;
          ts = null;
          if (silent) { // init-swap: άσε το native περιεχόμενο, γύρνα το native pagination
            if (pagWrap && natPag != null) { pagWrap.innerHTML = natPag; snapshot.pag = natPag; }
            restoreEarlyHidden(); // πλήρες fail-open: πίσω στο άθικτο native, τίποτα κρυφό
          } else {
            setLoading(false);
            location.href = tsHref(n); // native navigation — σωστό περιεχόμενο πάντα
          }
          return;
        }
        if (strays.length && n <= ts.inPages) {
          /* Σ08-01β: S&D index-lag — φρεσκο-εξαντλημένα που δεν έφυγαν ακόμη από
             το stream-1 ΔΕΝ γκρεμίζουν τον engine (το παλιό kill άφηνε ΟΛΗ τη
             συνεδρία με ανακατεμένα εξαντλημένα)· κρύβονται μόνο τα ίδια — ανήκουν
             στο τέλος. >2 strays = γνήσια χαλασμένο φίλτρο → πλήρες fail-open πάνω.
             Σε σελίδες εξαντλημένων (n > inPages) τα ≤2 «διαθέσιμα» strays =
             restock σε μετάβαση → μένουν ορατά (αγοράσιμα, κανένα κρύψιμο). */
          strays.forEach(function (c) {
            var it = c.closest('.product-grid__item') || c;
            it.remove();
          });
        }
        grid.innerHTML = newGrid.innerHTML;
        tsPagination(n);
        snapshot = { grid: grid.innerHTML, pag: pagWrap ? pagWrap.innerHTML : '' };
        if (descBlock) descBlock.hidden = n !== 1;
        if (push !== false) history.pushState({ srv: true }, '', tsHref(n));
        if (!silent) { scrollToGrid(); setLoading(false); }
      })
      .catch(function () { if (!silent) { setLoading(false); location.href = tsHref(n); } });
  }

  // ---------- m2 off-canvas φίλτρα (mobile) — μεταφέρθηκε εδώ από το
  // collection.liquid section-JS (TASK 62στ: το section-JS δεν φορτώνει στο
  // /search· το asset φορτώνει και στα δύο = single-source) ----------
  var filtersOpen = document.querySelector('[data-filters-open]');
  var filtersPanel = document.querySelector('[data-filters-panel]');
  var filtersOverlay = document.querySelector('[data-filters-overlay]');
  var filtersClose = document.querySelector('[data-filters-close]');
  var filtersApply = document.querySelector('[data-filters-apply]');
  /* Β.7 Σ07-15: v4β scroll-lock και ΕΔΩ (το drawer ΔΕΝ είναι dialog → εκτός κεντρικού
     showModal-patch)· ίδια τεχνική: η σελίδα ΔΕΝ αγγίζεται, touchmove προς το background
     = preventDefault, επιτρεπτό ΜΟΝΟ μέσα στο drawer (που σκρολάρει ο ίδιος), pinch ελεύθερο.
     Το body.overflow μένει ως δίχτυ για desktop-narrow/Android. */
  function drawerTouch(e) {
    if (e.touches && e.touches.length > 1) return; /* pinch ελεύθερο */
    if (!filtersPanel.contains(e.target)) e.preventDefault();
  }
  function setFilters(open) {
    if (!filtersPanel) return;
    filtersPanel.classList.toggle('is-open', open);
    if (filtersOverlay) filtersOverlay.hidden = !open;
    if (filtersOpen) filtersOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) document.addEventListener('touchmove', drawerTouch, { passive: false });
    else document.removeEventListener('touchmove', drawerTouch, { passive: false });
  }
  if (filtersOpen && filtersPanel) {
    filtersOpen.addEventListener('click', function () { setFilters(true); });
    if (filtersClose) filtersClose.addEventListener('click', function () { setFilters(false); });
    if (filtersOverlay) filtersOverlay.addEventListener('click', function () { setFilters(false); });
    if (filtersApply) filtersApply.addEventListener('click', function () { setFilters(false); });
  }

  // ---------- events ----------
  document.addEventListener('click', function (e) {
    // sidebar φίλτρα → engine toggle (native href = fallback σε βλάβη)
    var fLink = e.target.closest('[data-filter-item] a');
    if (fLink) {
      if (engineBroken) return; // native navigation
      e.preventDefault();
      lastNativeHref = fLink.href;
      var li = fLink.closest('[data-filter-item]');
      var g = li.closest('[data-filter-group]').getAttribute('data-filter-group');
      var t = li.getAttribute('data-tag');
      sel[g] = sel[g] || {};
      if (sel[g][t]) delete sel[g][t]; else sel[g][t] = true;
      apply(1);
      return;
    }
    // AUDIT Β4α: «Καθαρισμός φίλτρων» από το zero-results empty-state —
    // μηδενισμός επιλογών + πλήρες εύρος τιμής → apply(1) πέφτει στο restore()
    // (φυσικό μονοπάτι: grid/pagination/URL γυρνούν στην αφιλτράριστη προβολή)
    var clr = e.target.closest('[data-engine-clear]');
    if (clr) {
      e.preventDefault();
      sel = {};
      priceSel = bounds ? [bounds[0], bounds[1]] : null;
      if (rMin) syncPriceUI();
      apply(1);
      return;
    }
    // engine chips (αφαίρεση)
    var rm = e.target.closest('[data-engine-remove-tag]');
    if (rm) {
      e.preventDefault();
      var rg = rm.getAttribute('data-engine-group');
      var rt = rm.getAttribute('data-engine-remove-tag');
      if (sel[rg]) delete sel[rg][rt];
      apply(1);
      return;
    }
    // pagination
    if (pagWrap && pagWrap.contains(e.target)) {
      var ep = e.target.closest('[data-engine-page]');
      if (ep) {
        e.preventDefault();
        render(parseInt(ep.getAttribute('data-engine-page'), 10));
        updateURL();
        scrollToGrid();
        return;
      }
      // TASK 65: two-stream σελίδες (αφιλτράριστο mode με εξαντλημένα)
      var tsp = e.target.closest('[data-ts-page]');
      if (tsp) {
        e.preventDefault();
        tsGo(parseInt(tsp.getAttribute('data-ts-page'), 10), true, false);
        return;
      }
      var sLink = e.target.closest('a.pagination__num, a.pagination__nav');
      if (sLink && !engineOn) {
        e.preventDefault();
        ajaxServerPage(sLink.href);
      }
    }
  });

  window.addEventListener('popstate', function () {
    var st = parseURL();
    if (st.active) {
      apply(st.page, false);
      if (rMin) syncPriceUI();
    } else if (engineOn) {
      restore(false);
    } else if (ts) {
      // TASK 65: two-stream ιστορικό — ?page = global two-stream αρίθμηση
      tsGo(curServerPage(), false, false);
    } else {
      // server-mode ιστορικό (σελίδες) — φέρε τη σωστή σελίδα χωρίς reload
      ajaxServerPage(location.href, false);
    }
  });

  // ---------- init ----------
  // seed από server-rendered tag-URL κατάσταση (no-JS μονοπάτι → engine συνέχεια)
  document.querySelectorAll('[data-filter-item].is-checked').forEach(function (li) {
    var g = li.closest('[data-filter-group]').getAttribute('data-filter-group');
    sel[g] = sel[g] || {};
    sel[g][li.getAttribute('data-tag')] = true;
  });

  // TASK 20γ: seed ορίων από τα server-rendered προϊόντα (data-price-seed,
  // cents) → η μπάρα ορατή ΑΜΕΣΩΣ στο load· το lite/full fetch μόνο διευρύνει
  var seedAttr = root.getAttribute('data-price-seed');
  if (seedAttr) {
    var seedParts = seedAttr.split(',');
    widenBounds([Math.floor(seedParts[0] / 100), Math.ceil(seedParts[1] / 100)]);
  }

  // TASK 62ζ: lite-fetch ΑΜΕΣΩΣ (το sidebar είναι veiled μέχρι το prune)
  // TASK 65: με το lite έτοιμο → two-stream init (εξαντλημένα στο τέλος)
  fetchLite().then(initTwoStream).catch(function () {});

  var st = parseURL();
  if (st.active) {
    // deep-link: άνοιξε τα σχετικά groups + εφάρμοσε
    for (var g in sel) {
      if (Object.keys(sel[g]).length) {
        var d = document.querySelector('[data-filter-group="' + cssEscape(g) + '"]');
        if (d) d.open = true;
      }
    }
    if (new URLSearchParams(location.search).get('price') && priceFilter) priceFilter.open = true;
    apply(st.page, false);
    // TASK 20γ: με seed το initPriceUI τρέχει ΠΡΙΝ το parseURL → ξανασυγχρόνισε
    // τις λαβές/inputs στο deep-link εύρος (πριν, τα bounds έρχονταν πάντα μετά)
    if (rMin) syncPriceUI();
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { fetchData().catch(function () {}); }, { timeout: 4000 });
  } else {
    setTimeout(function () { fetchData().catch(function () {}); }, 2500);
  }
})();
